/** Shown when `VITE_MAINTENANCE_MODE` is enabled at build time. */
export default function MaintenancePage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-[#edeae8] px-6 text-center">
      <p className="text-xs font-semibold uppercase tracking-[0.28em] text-primary">XMEGAMI Admin</p>
      <h1 className="mt-6 max-w-lg text-3xl font-semibold tracking-tight text-neutral-900 md:text-4xl">
        We’ll be back soon
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-neutral-600">
        The admin panel is temporarily under maintenance. Please try again in a little while.
      </p>
      <p className="mt-10 text-xs text-neutral-400">系统维护中，请稍后再试。</p>
    </main>
  );
}
